import React from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import { Checkbox, Icon } from "../../common/";
import Helper from "../../../helper/Helper";
import SalesRow from "./salesRow/SalesRow";
import SalesRowBox from "./salesRowBox/SalesRowBox";
import styles from "../../orders/orderTable/OrderTable.scss";

const ProductTable = props => {
  const {
    browser,
    data,
    searchString,
    toggleCheckbox,
    seller,
    selectedItems,
    onQtyChange,
    selectAll,
    allSelected,
    indeterminate,
    dropdown,
    status,
    onUpdateQty,
    sortColumn
  } = props;

  const property = Helper.validator(data);

  const rows =
    data && !_.isEmpty(data)
      ? data.map((item, index) => {
          return (
            <SalesRow
              item={item}
              property={property}
              searchString={searchString}
              toggleCheckbox={toggleCheckbox}
              seller={seller}
              onQtyChange={onQtyChange}
              selectedItems={selectedItems}
              dropdown={dropdown}
              key={index}
              status={status}
              onUpdateQty={onUpdateQty}
            />
          );
        })
      : "";

  const box =
    data && !_.isEmpty(data)
      ? data.map((item, index) => (
          <SalesRowBox
            item={item}
            property={property}
            searchString={searchString}
            toggleCheckbox={toggleCheckbox}
            seller={seller}
            onQtyChange={onQtyChange}
            selectedItems={selectedItems}
            key={index}
            dropdown={dropdown}
            status={status}
            onUpdateQty={onUpdateQty}
          />
        ))
      : "";

  const dir = props.dir && props.dir === "asc" ? "desc" : "asc";

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.tablet ? (
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {property.haveName ? (
                <th>{I18n.getText("product-table.name")}</th>
              ) : (
                ""
              )}
              {property.haveItemNr ? (
                <th>{I18n.getText("order-details.item-nr")}</th>
              ) : (
                ""
              )}
              {property.haveDestinationCountry ? (
                <th>{I18n.getText("sales.destination-country")}</th>
              ) : (
                ""
              )}
              {property.havePSkuUnique ? (
                <th>{I18n.getText("offer.p-sku-unique")}</th>
              ) : (
                ""
              )}
              {property.haveSku ? (
                <th>{I18n.getText("offer.sku")}</th>
              ) : (
                ""
              )}
              {property.haveInvoiceDate ? (
                <th>{I18n.getText("sales.invoice-date")}</th>
              ) : (
                ""
              )}
              <th>{I18n.getText("imports.status")}</th>
              {property.haveShippedDate ? (
                <th>{I18n.getText("sales.shipped-date")}</th>
              ) : (
                ""
              )}

              <th>{I18n.getText("sales.base-price")}</th>
              <th>{I18n.getText("sales.fees")}</th>
              <th>{I18n.getText("sales.pending-payment")}</th>
              <th>{I18n.getText("sales.net-payment")}</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      ) : (
        box
      )}
    </div>
  );
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/sales/salesTable/SalesTable.js